<script lang="ts">
    import type { MenuInteractionEventPayload } from 'header/types';
    import { PortletMenuActions } from 'header/types';

    import SettingsForm from './settings/SettingsForm.svelte';
    import DialogContentPlaceholder from './DialogContentPlaceholder.svelte';
    import DialogFilters from './DialogFilters.svelte';
    import SupportForm from './SupportForm.svelte';
    import DialogInfo from './DialogInfo.svelte';
    import DialogPerformance from './DialogPerformance.svelte';

    interface Props {
        dialogDefinition: MenuInteractionEventPayload | null;
    }

    let { dialogDefinition = null }: Props = $props();

    let DialogContentComponent = $derived(getDialogContentComponent(dialogDefinition?.tag));

    function getDialogContentComponent(dialogItem?: PortletMenuActions) {
        switch (dialogItem) {
            case PortletMenuActions.INFO:
                return DialogInfo;

            case PortletMenuActions.SETTINGS:
                return SettingsForm;

            case PortletMenuActions.FILTERS:
                return DialogFilters;

            case PortletMenuActions.SUPPORT:
                return SupportForm;

            case PortletMenuActions.PERFORMANCE:
                return DialogPerformance;

            default:
                return DialogContentPlaceholder;
        }
    }
</script>

<div>
    <svelte:component this={DialogContentComponent} definition={dialogDefinition} />
</div>

<style>
</style>
